export const formatDatesForExcel = (date: string | null) : string => {
    if (date) {
        let formattedDate = new Date(date).toLocaleString();
        formattedDate = formattedDate.substring(0, 17);
        return formattedDate;
    } else {
        return "";
    }
};

export const formatDatesNoTImeForExcel = (date: string | null) : string => {
    if (date) {
        let formattedDate = new Date(date).toLocaleDateString();
        formattedDate = formattedDate.substring(0, 10);
        return formattedDate;
    } else {
        return "";
    }
}
